import { render } from "./component-payer-bank.vue?vue&type=template&id=24032c21"
import script from "./component-payer-bank.vue?vue&type=script&setup=true&lang=js"
export * from "./component-payer-bank.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-payer-bank.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24032c21"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24032c21', __exports__)) {
    api.reload('24032c21', __exports__)
  }
  
  module.hot.accept("./component-payer-bank.vue?vue&type=template&id=24032c21", () => {
    api.rerender('24032c21', render)
  })

}


export default __exports__